export default class FilterModule {
  constructor(controller) {
    this.controller = controller;
  }

  // Função para normalizar texto removendo acentos
  normalizeText(text) {
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  initialize() {
    this.initFiltro();
  }

  initFiltro() {
    if (!this.controller.hasIntegrantesColumnTarget) return;

    this.controller.filtroIntegrantesTarget.addEventListener("input", (e) => {
      const filtro = this.normalizeText(e.target.value);
      const cards =
        this.controller.integrantesColumnTarget.querySelectorAll(
          ".kanban-card"
        );

      cards.forEach((card) => {
        const nome = this.normalizeText(
          card.querySelector(".nome-integrante").textContent
        );

        const roles = this.normalizeText(card.dataset.roles);

        if (nome.includes(filtro) || roles.includes(filtro)) {
          card.style.display = "";
        } else {
          card.style.display = "none";
        }
      });
    });
  }
}
